import { BaseController } from '@shared/basecontroller.controller';

export class AccountReminderWidgetController extends BaseController {
  constructor(AppService) {
    'ngInject';

    super(AppService);
  }

  $onInit() {
    this.session = this.getSession();
  }

  hasReminder() {
    return !this.session.isVerified() || (!this.session.hasSetupTransactionAuthentication());
  }

  needsToBeVerified() {
    return !this.session.isVerified();
  }

  needsToSetupAuthentication() {
    return !this.session.hasSetupTransactionAuthentication();
  }
}

export default AccountReminderWidgetController;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/account-reminder-widget/account-reminder-widget.controller.js